import type { RowData } from "@tanstack/react-table";
import type { ReactNode } from "react";
import type {
  RecordPresentationContext,
  RecordPresentationMode,
} from "./types";

export type PresentationRenderers<TData extends RowData> = Partial<
  Record<
    Exclude<RecordPresentationMode, "table">,
    ((context: RecordPresentationContext<TData>) => ReactNode) | undefined
  >
>;

export function availablePresentationModes<TData extends RowData>(
  declared: RecordPresentationMode[],
  renderers: PresentationRenderers<TData>,
): RecordPresentationMode[] {
  return declared.filter(
    (mode) => mode === "table" || renderers[mode] !== undefined,
  );
}

export function renderPresentation<TData extends RowData>(
  mode: RecordPresentationMode,
  renderers: PresentationRenderers<TData>,
  context: RecordPresentationContext<TData>,
): ReactNode {
  if (mode === "table") return null;
  return renderers[mode]?.(context) ?? null;
}
